export default "__VITE_ASSET__DgbvEuj2__"